import { css } from '@emotion/react';
import { Divider, Link, Typography } from '@mui/material';
import { FC } from 'react';
import { IPersonDataModel } from '../../../../data-models/person.data-model';
import { useFetchAndUpdatePersonEmails } from '../../../../services/hooks/usePersonEmails';
import { ActivityDetails } from '../../../CompanyProfiles2/Header/ActivityDetails';
import { getEngagementSummary } from '../../../CompanyProfiles2/utils/getPersonActivityData';
import { StrongestConnections } from '../../People/CellRenderers/StrongestConnection';
import { FMT } from '../../../../util/formatter-service';

const Container = css`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  align-items: start;
  &.loading {
    opacity: 0.7;
    pointer-events: none;
  }
`;

const Card = css`
  box-shadow: 0px 4px 10px rgba(44, 46, 49, 0.1);
  border-radius: 4px;
  padding: 1rem;
  margin-top: 1rem;
`;

const MainInfo = css`
  background: var(--mui-colors-neutral-2);
  border-radius: 4px;
  padding: 1.5rem;
  display: grid;
  grid-template-columns: minmax(8rem, 1fr) 4fr;
  row-gap: 1rem;
`;

const titleStyles = { marginBottom: '0.5rem' };

interface IPersonGeneralInfoProps {
  person: IPersonDataModel;
  companyId: number;
}
export const PersonGeneralInfo: FC<IPersonGeneralInfoProps> = ({ person, companyId }) => {
  const { primaryEmail, secondaryEmails } = person;
  const { loading } = useFetchAndUpdatePersonEmails(person, companyId);

  const location = person.locations?.[0];
  const { activity, relationships } = person;

  const engagementSummary = getEngagementSummary(activity);

  return (
    <div css={Container} className={loading ? 'loading' : ''}>
      <Typography css={MainInfo} variant='body2' component='div'>
        <span>Location</span>
        <span>{FMT.format('location', location)}</span>
        <span>Primary email</span>
        {primaryEmail ? (
          <Link href={`mailto:${primaryEmail}`} underline='none'>
            {primaryEmail}
          </Link>
        ) : (
          <div></div>
        )}
        <span>Secondary emails</span>
        <div>
          {secondaryEmails?.map((email, i) => (
            <Link key={email} href={`mailto:${email}`} underline='none'>
              {email}
              {i < secondaryEmails.length - 1 && ', '}
            </Link>
          ))}
        </div>
      </Typography>
      <div>
        <Typography variant='body2'>Relationships Intelligence</Typography>
        {(relationships.length > 0 || Boolean(activity)) && (
          <div css={Card}>
            {relationships.length > 0 && (
              <StrongestConnections relationships={relationships} titleStyle={titleStyles} />
            )}

            {relationships.length > 0 && activity && <Divider style={{ margin: '1rem 0' }} />}
            {activity && <ActivityDetails engagementSummary={engagementSummary} />}
          </div>
        )}
      </div>
    </div>
  );
};
